<template>
  <div class="flex-column a-center j-center text-white module-bg">
    <span class="ai-animate main-txt" swiper-animate-effect="fadeInDown" swiper-animate-delay="0" swiper-animate-speed="1_5">让家长省心又放心</span>
    <div class="flex j-between content">
      <div
        v-for="(item, key) in subs"
        :key="key"
        class="ai-animate sub-item flex-column a-center j-center"
        :swiper-animate-effect="key % 2 === 0 ? 'fadeInLeft' : 'fadeInRight'" swiper-animate-speed="1_5" swiper-animate-delay="0_5">
        <img class="w-200" :src="item.icon">
        <div class="m-t-50 text-normal item-label">{{item.label}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import icon1 from '../assets/module-5-1.png'
import icon2 from '../assets/module-5-2.png'
export default {
  data () {
    return {
      subs: {
        0: {
          icon: icon1,
          label: '正版学习内容，优质练习题目， 科学学习方法，名师指导课程， 孩子成绩怎能不提高？'
        },
        1: {
          icon: icon2,
          label: '全面的学情分析报告，让家长随时了解孩子学习动态，孩子成长， 家校协同，共同护航。'
        },
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main-txt {
  font-size: 2.25em;
  font-weight: 500;
  margin-bottom: 100px;
}

.module-bg {
  background: linear-gradient(to bottom, #5997FF, #56A5FF, #60B3FF);
  .content {
    width: 1000px;
  }
}

.sub-item {
  width:400px;
  height:450px;
  background:rgba(255,255,255,1);
  border-radius:8px;
  font-size: 18px;
  padding: 50px;
  position: relative;
  .item-label {
    line-height: 30px;
    text-align: center;
  }
  &:before {
    content: '';
    position: absolute;
    width: 430px;
    left: -15px;
    top: -6px;
    height: 12px;
    background:rgba(229,242,255,1);
    border-radius:10px;
  }
}
@media (max-width: 1024px) {
  .module-bg {
    padding: 0 30px;
    .content {
      width: 100%;
    }
  }
  .sub-item {
    width:100%;
    max-width: 320px;
    height:auto;
    font-size: 12px;
    padding: 10px 16px;
    .item-label {
      line-height: 18px;
    }
    &:before {
      content: '';
      position: absolute;
      width: calc(100% + 20px);
      left: -10px;
      top: -6px;
      height: 12px;
      background:rgba(229,242,255,1);
      border-radius:10px;
    }
  }
}
@media (max-width: 767px) {
  .main-txt {
    font-size: 24px;
    margin-bottom: 10px;
  }
  .module-bg {
    padding: 0 30px;
    .content {
      width: 100%;
    }
  }
  .flex {
    flex-wrap: wrap;
  }
  .sub-item {
    width:100%;
    max-width: 300px;
    height:auto;
    font-size: 12px;
    padding: 10px 16px;
    margin: auto;
    .item-label {
      line-height: 18px;
    }
    &:before {
      content: '';
      position: absolute;
      width: calc(100% + 20px);
      left: -10px;
      top: -6px;
      height: 12px;
      background:rgba(229,242,255,1);
      border-radius:10px;
    }
    .w-200 {
      width: 120px;
    }
    .m-t-50 {
      margin-top: 10px
    }
  }
  .sub-item:nth-child(1) {
    margin-bottom: 20px
  }
}
</style>
